import { A, D } from "@mobily/ts-belt";
import PropTypes from "prop-types";
import * as React from "react";
import s from "./CategoryFilter.module.css";

const ChevronIcon = ({ open }) => (
  <svg
    className={`${s.chevron}${open ? ` ${s.chevronOpen}` : ""}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

ChevronIcon.propTypes = {
  open: PropTypes.bool.isRequired,
};

export default function CategoryFilter({
  expandedByDefault = false,
  categories,
  selected,
  setSelected,
}) {
  const [isOpen, setIsOpen] = React.useState(expandedByDefault);
  const options = Object.values(categories);

  return (
    <div className={s.section}>
      <button
        type="button"
        className={s.headerBtn}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <ChevronIcon open={isOpen} />
        Categories
      </button>

      <div className={`${s.collapse}${isOpen ? ` ${s.collapseOpen}` : ""}`}>
        <div className={s.collapseInner}>
          <div className={s.list}>
            {options.map((category) => {
              const { id, name, subcategories } = category;
              const parentChecked = D.isNotEmpty(selected[id] ?? {});
              const parentInputId = `cat-parent-${id}`;

              return (
                <div key={id} className={s.group}>
                  <div className={s.row}>
                    <input
                      id={parentInputId}
                      className={s.checkbox}
                      type="checkbox"
                      checked={parentChecked}
                      onChange={() => {
                        if (
                          selected[id] &&
                          Object.keys(selected[id]).length ===
                            subcategories.length
                        ) {
                          return setSelected(D.deleteKey(id));
                        }

                        setSelected(
                          D.merge({
                            [id]: subcategories.reduce((result, c) => {
                              result[c.id] = true;
                              return result;
                            }, {}),
                          }),
                        );
                      }}
                    />
                    <label htmlFor={parentInputId} className={s.parentLabel}>
                      {name}
                    </label>
                  </div>

                  {subcategories.map((subcategory) => {
                    const { id: subcategoryId, name: subName } = subcategory;
                    const inputId = `cat-${id}-${subcategoryId}`;

                    return (
                      <div key={subcategoryId} className={s.subRow}>
                        <input
                          id={inputId}
                          className={s.checkbox}
                          type="checkbox"
                          checked={!!selected[id]?.[subcategoryId]}
                          onChange={() => {
                            if (!selected[id]?.[subcategoryId]) {
                              return setSelected(
                                D.merge({
                                  [id]: D.merge(selected[id] ?? {}, {
                                    [subcategoryId]: true,
                                  }),
                                }),
                              );
                            }

                            const selectedKeys = Object.keys(
                              selected[id] ?? {},
                            );

                            if (
                              selectedKeys.length === 1 &&
                              Number(A.head(selectedKeys)) === subcategoryId
                            ) {
                              return setSelected(D.deleteKey(id));
                            }

                            setSelected(
                              D.merge({
                                [id]: D.deleteKey(
                                  selected[id] ?? {},
                                  subcategoryId,
                                ),
                              }),
                            );
                          }}
                        />
                        <label htmlFor={inputId} className={s.checkboxLabel}>
                          {subName}
                        </label>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

CategoryFilter.propTypes = {
  expandedByDefault: PropTypes.bool,
  categories: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  setSelected: PropTypes.func.isRequired,
};
